import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import AboutSummary from "./sections/AboutSummary";
import ServicesOverview from "./sections/ServicesOverview";
import StartAConversation from "./sections/StartAConversation";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <AboutSummary />
      <ServicesOverview />
      <StartAConversation />
      <Footer />
    </div>;
}